import { render, staticRenderFns } from "./page55.vue?vue&type=template&id=c20b5bfe&scoped=true&"
import script from "./page55.vue?vue&type=script&lang=js&"
export * from "./page55.vue?vue&type=script&lang=js&"
import style0 from "./page55.vue?vue&type=style&index=0&id=c20b5bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20b5bfe",
  null
  
)

export default component.exports